import AUDIT_COMMENT_BACKLOG_PRIORITY_CHANGED from "./AUDIT_COMMENT_BACKLOG_PRIORITY_CHANGED.vue"
import AUDIT_COMMENT_CONTENT_CHANGE_CHANGED from "./AUDIT_COMMENT_CONTENT_CHANGE_CHANGED.vue"
import AUDIT_COMMENT_DEFINITIONS_OF_DONE_CHANGED from "./AUDIT_COMMENT_DEFINITIONS_OF_DONE_CHANGED.vue"
import AUDIT_COMMENT_DELETE_TASK_CHANGED from "./AUDIT_COMMENT_DELETE_TASK_CHANGED.vue"
import AUDIT_COMMENT_DELETED_CHANGED from "./AUDIT_COMMENT_DELETED_CHANGED.vue"
import AUDIT_COMMENT_EPIC_CHANGED from "./AUDIT_COMMENT_EPIC_CHANGED.vue"
import AUDIT_COMMENT_FILE_METADATA_IS_DELETED_CHANGED from "./AUDIT_COMMENT_FILE_METADATA_IS_DELETED_CHANGED.vue"
import AUDIT_COMMENT_IDEA_CONVERTED_RESOURCE_CHANGED from "./AUDIT_COMMENT_IDEA_CONVERTED_RESOURCE_CHANGED.vue"
import AUDIT_COMMENT_IDEA_CONVERTED_TO_EPIC_CHANGED from "./AUDIT_COMMENT_IDEA_CONVERTED_TO_EPIC_CHANGED.vue"
import AUDIT_COMMENT_IDEA_CONVERTED_TO_FEATURE_CHANGED from "./AUDIT_COMMENT_IDEA_CONVERTED_TO_FEATURE_CHANGED.vue"
import AUDIT_COMMENT_IDEA_CONVERTED_TO_ITEM_CHANGED from "./AUDIT_COMMENT_IDEA_CONVERTED_TO_ITEM_CHANGED.vue"
import AUDIT_COMMENT_IDEA_READY_CHANGED from "./AUDIT_COMMENT_IDEA_READY_CHANGED.vue"
import AUDIT_COMMENT_IDEA_SIZE_CHANGED from "./AUDIT_COMMENT_IDEA_SIZE_CHANGED.vue"
import AUDIT_COMMENT_IDEA_STATUS_CHANGED from "./AUDIT_COMMENT_IDEA_STATUS_CHANGED.vue"
import AUDIT_COMMENT_ITEM_CONVERTED_TO_EPIC_CHANGED from "./AUDIT_COMMENT_ITEM_CONVERTED_TO_EPIC_CHANGED.vue"
import AUDIT_COMMENT_ITEM_TYPE_CHANGED from "./AUDIT_COMMENT_ITEM_TYPE_CHANGED.vue"
import AUDIT_COMMENT_MOVE_TO_TASK_CHANGED from "./AUDIT_COMMENT_MOVE_TO_TASK_CHANGED.vue"
import AUDIT_COMMENT_OWNER_CHANGED from "./AUDIT_COMMENT_OWNER_CHANGED.vue"
import AUDIT_COMMENT_RESTORE_TASK_CHANGED from "./AUDIT_COMMENT_RESTORE_TASK_CHANGED.vue"
import AUDIT_COMMENT_SEVERITY_LEVEL_CHANGED from "./AUDIT_COMMENT_SEVERITY_LEVEL_CHANGED.vue"
import AUDIT_COMMENT_SPRINT_CHANGED from "./AUDIT_COMMENT_SPRINT_CHANGED.vue"
import AUDIT_COMMENT_STATUS_CHANGED from "./AUDIT_COMMENT_STATUS_CHANGED.vue"
import AUDIT_COMMENT_STORY_POINTS_CHANGED from "./AUDIT_COMMENT_STORY_POINTS_CHANGED.vue"
import AUDIT_COMMENT_STRUCTURED_DESCRIPTION_CHANGED from "./AUDIT_COMMENT_STRUCTURED_DESCRIPTION_CHANGED.vue"
import AUDIT_COMMENT_TASKS_CHANGED from "./AUDIT_COMMENT_TASKS_CHANGED.vue"
import AUDIT_COMMENT_TEAM_CHANGED from "./AUDIT_COMMENT_TEAM_CHANGED.vue"
import AUDIT_COMMENT_TITLE_CHANGED from "./AUDIT_COMMENT_TITLE_CHANGED.vue"
import AUDIT_COMMENT_UNIMPLEMENTED from "./AUDIT_COMMENT_UNIMPLEMENTED.vue"
import REGULAR_COMMENT from "./REGULAR_COMMENT.vue"

export default {
  AUDIT_COMMENT_STRUCTURED_DESCRIPTION_CHANGED,
  /** Keeps Acceptance Criteria changes consistent with Description history. */
  AUDIT_COMMENT_ACCEPTANCE_CRITERIA_CHANGED: AUDIT_COMMENT_STRUCTURED_DESCRIPTION_CHANGED,
  AUDIT_COMMENT_SPEC_CHANGED: AUDIT_COMMENT_STRUCTURED_DESCRIPTION_CHANGED,
  AUDIT_COMMENT_OWNER_CHANGED,
  AUDIT_COMMENT_TITLE_CHANGED,
  AUDIT_COMMENT_ITEM_TYPE_CHANGED,
  AUDIT_COMMENT_UNIMPLEMENTED,
  AUDIT_COMMENT_TEAM_CHANGED,
  AUDIT_COMMENT_STORY_POINTS_CHANGED,
  AUDIT_COMMENT_EPIC_CHANGED,
  AUDIT_COMMENT_STATUS_CHANGED,
  AUDIT_COMMENT_SPRINT_CHANGED,
  AUDIT_COMMENT_SEVERITY_LEVEL_CHANGED,
  AUDIT_COMMENT_TASKS_CHANGED,
  AUDIT_COMMENT_DEFINITIONS_OF_DONE_CHANGED,
  AUDIT_COMMENT_BACKLOG_PRIORITY_CHANGED,
  REGULAR_COMMENT,
  AUDIT_COMMENT_MOVE_TO_TASK_CHANGED,
  AUDIT_COMMENT_DELETE_TASK_CHANGED,
  AUDIT_COMMENT_RESTORE_TASK_CHANGED,
  AUDIT_COMMENT_FILE_METADATA_IS_DELETED_CHANGED,
  AUDIT_COMMENT_CONTENT_CHANGE_CHANGED,
  AUDIT_COMMENT_DELETED_CHANGED,
  AUDIT_COMMENT_ITEM_CONVERTED_TO_EPIC_CHANGED,
  AUDIT_COMMENT_IDEA_READY_CHANGED,
  AUDIT_COMMENT_IDEA_TITLE_CHANGED: AUDIT_COMMENT_TITLE_CHANGED,
  AUDIT_COMMENT_IDEA_SIZE_CHANGED,
  AUDIT_COMMENT_IDEA_STATUS_CHANGED,
  AUDIT_COMMENT_IDEA_CONVERTED_TO_EPIC_CHANGED,
  AUDIT_COMMENT_IDEA_CONVERTED_TO_FEATURE_CHANGED,
  AUDIT_COMMENT_IDEA_CONVERTED_TO_ITEM_CHANGED,
  AUDIT_COMMENT_IDEA_CONVERTED_RESOURCE_CHANGED
}
